import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { useState } from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

export default function AddRoleDialog(props) {

    const classes = useStyles();
    const [role, setRole] = useState(null);
    const [roleSelected, setRoleSelected] = useState(null);

    const changeRole = (event) => {
        setRoleSelected(true);
        setRole(event.target.value);
    }

    const closeDialog = () => {
        setRole(null);
        props.closeDialog();
    }

    const action = () => {
        setRole(null);
        props.action(role);
    }

    return (

        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            aria-labelledby="draggable-dialog-title"
            onClose={props.closeDialog}
        >
            <DialogTitle className={classes.dialogTitle} id="draggable-dialog-title">
                {"Selecteer rol"}
            </DialogTitle>
            <DialogContent>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select2"
                    className={classes.selectField}
                    value={role}
                    onChange={(e) => changeRole(e)}
                >
                    {props.allRoles.map(x => {
                        return (
                            <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)
                    })}

                </Select>
            </DialogContent>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.button} style={{marginRight:"10px"}} onClick={closeDialog} >
                        {"ANNULEER"}
                    </Button>
                    <Button className={classes.button} disabled={!roleSelected} onClick={() => action()} >
                        {"VOEG TOE"}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        margin: "auto"
    },
    buttons: {
        textAlign: "center",
        width: "100%",
        marginBottom:"10px",
        marginTop:"20px"
    },
    button:{
        border: "1px solid #E8E8E8",
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "24px !important",
        },
        paddingTop: "20px",
    },
    selectField: {
        width: "200px",
        height: "40px",
        borderRadius: "5px",
        backgroundColor: "white",
        border: "1px solid #c1c2be",
        paddingLeft: "10px",
        "& .MuiInput-root": {
            height: "40px",
        },
        "& .MuiInput-underline:before": {
            borderBottom: "none !important"
        },
        "& .MuiInput-underline:after": {
            borderBottom: "none !important"
        },
        "& .MuiFormHelperText-root.Mui-error": {
            marginTop: "10px",
            height: "20px",
            backgroundColor: "white",
            display: 'block'
        },
        float: "left"
    },
}));
